import user from "./user";
import order from "./order";
import activity from "./activity";
import admin from "./admin";
import common from "./common";
import mask from "./mask";

export default [...common, ...mask, ...user, ...order, ...activity, ...admin];
